import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ViewContractSell from "./ViewContractSell";
import { change_Lang } from "../../../actions/Helper_action";
import {
  Update_SellContract,
  View_Sell_Contract,
} from "../../../actions/Invoice_action";
import { Get_List_Sell_Contracts } from "../../../actions_agent/Invoice_action";
export class EditContractSell extends Component {
  componentDidMount() {
    // this.props.View_Sell_Contract(
    //   this.props.match.params.id,
    //   this.props.match.params.index
    // );
  }
  render() {
    const {
      sell_invoice_obj,
      lang,
      change_Lang,
      sell_obj_avilabeId,
      Update_SellContract,
      user,
      name_arb,
      name_en,
      name_krd,
      Get_List_Sell_Contracts,
      onClose,
    } = this.props;
    return (
      <Fragment>
        <ViewContractSell
          sell_invoice_obj={sell_invoice_obj}
          lang={lang}
          change_Lang={change_Lang}
          View_Sell_Contract={this.props.View_Sell_Contract}
          // index_sell_contract={this.props.match.params.index}
          Update_SellContract={Update_SellContract}
          sell_obj_avilabeId={sell_obj_avilabeId}
          user={user}
          name_arb={name_arb}
          name_en={name_en}
          name_krd={name_krd}
          Get_List_Sell_Contracts={Get_List_Sell_Contracts}
          onClose={onClose}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sell_invoice_obj: state.Invoice_Reducer.sell_invoice_obj,
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
    sell_contracts: state.Invoice_Reducer.sell_contracts,
    sell_obj_avilabeId: state.Invoice_Reducer.sell_obj_avilabeId,
    name_krd: state.HelperReducer.name_krd,
    name_arb: state.HelperReducer.name_arb,
    name_en: state.HelperReducer.name_en,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    View_Sell_Contract: (id, index) => dispatch(View_Sell_Contract(id, index)),
    Update_SellContract: (id, data) => dispatch(Update_SellContract(id, data)),
    Get_List_Sell_Contracts: () => dispatch(Get_List_Sell_Contracts()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditContractSell);
